import { t } from '@/i18n';
import { HyperlinkTarget } from '@/model';
import { z } from 'zod';

const ACCEPTED_IMAGE_TYPES = ['image/jpeg', 'image/jpg', 'image/png'];

export const modalFormSchema = z.object({
  name: z
    .string()
    .min(1, t('pages.application_calendar_events.components.calendar_create_modal.schema.calendar_events_create_required_field')),
  place: z
    .string()
    .min(1, t('pages.application_calendar_events.components.calendar_create_modal.schema.calendar_events_create_required_field')),
  event_at: z
    .string()
    .min(1, t('pages.application_calendar_events.components.calendar_create_modal.schema.calendar_events_create_required_field')),
  hyperlink: z.string().optional(),
  hyperlink_target: z.nativeEnum(HyperlinkTarget),
  description: z.string().optional(),
  team_uuid: z.string().optional(),
  is_display: z.boolean(),
  file: z
    .any()
    .refine(
      file => !!file,
      t('pages.application_calendar_events.components.calendar_create_modal.schema.calendar_events_create_required_field'),
    )
    .refine(
      file => !file || ACCEPTED_IMAGE_TYPES.includes(file.type),
      t(
        'pages.application_calendar_events.components.calendar_create_modal.schema.calendar_events_create_invalid_file_extension',
      ),
    ),
});

export type ModalFormData = z.infer<typeof modalFormSchema>;
